import React, { Component } from 'react';
import { get, post } from 'axios';
import ShopingCartHeader from '../ShoppingCartHeader/ShoppingCartHeader';
import ShoppingCartItem from '../ShoppingCartItem/ShoppingCartItem';
import ShoppingCartCta from '../ShoppingCartCta/ShoppingCartCta';

import {getPurchaseAppData, transformPAData} from '../ShoppingCartUtils/PurchaseAppApi';
import {
    makeCartDataJsonString,
    removeItem,
    countItems,
    updateCartUIElement,
    removeCourseEventGoogleAnalytics
} from '../ShoppingCartUtils/Helpers';
import {updateSessionCartQuantity, removeFromSessionCart} from '../ShoppingCartUtils/SessionCart';
import './cart-page-styles.css';

class ShoppingCartApp extends Component {
    constructor(props){
        super(props);

        this.state = {
            error: null,
            errorMessage: null,
            isLoaded: false,
            sessionCartData: {...props.sessionCartData},
            domainId: props.domainId,
            purchaseApp: '',
            items: '',
            totalCost: '',
            subtotal: '',
            totalUpdating: true,
            totalCartItems: props.totalCartItems,
            cartString: 'Loading...',
            cartData: '',
            volumeDiscount: '',
            discountCode: '',
            discountCodeAttempt: false,
            discountNotApplicable: false,
            discountNotApplicableMessage: '',
            checkout_url: 'https://checkout.skyelearning.com/'
        }

        //Bind click hanlder references
        this.removeItemHandler = this.removeItemHandler.bind(this);
        this.applyDiscountClickHandler = this.applyDiscountClickHandler.bind(this);
        this.updateQuantityClickHandler = this.updateQuantityClickHandler.bind(this);
    }

    //Get the inital PA data based on session props passed in from view
    componentDidMount(){
        if(!this.props.testing) {
            this.handleInitialCartStatus();
        }

        var hostname =  window.location.host;
        if(hostname.indexOf('staging.skyelearning.com')>-1) {

            this.setState({
                checkout_url: 'https://checkout-staging.skyelearning.com/'
            })
        }else{
            this.setState({
                checkout_url: 'https://checkout.skyelearning.com/'
            })
        }
    }

   async  handleInitialCartStatus(){
       if(this.state.totalCartItems > 0){
         var response = await  getPurchaseAppData('/checkout/ordertotal', this.state.domainId, this.state.sessionCartData)

                   if(response.status === 200 && response.data.message === undefined){
                       this.setState({
                           purchaseApp: response.data,
                           items: transformPAData(this.state.sessionCartData, response.data),
                           totalUpdating: false,
                           totalCost: response.data.total,
                           subtotal: response.data.total_prediscount,
                           cartHasItems: true,
                           cartData: makeCartDataJsonString(response.data),
                           volumeDiscount: response.data.volume_discount,
                       })
                   }else{
                       this.setState({
                           error: true,
                           errorMessage: response.data.message
                       })
                   }

       }else{
           this.setState({
               cartString: 'No Items In Cart',
               totalUpdating: false,
           })
       }
    }
    //Called when remove button is clicked in the <ShoppingCartItem> component
    removeItemHandler(event){
        event.preventDefault();
        let itemCourseId = event.target.getAttribute("data-course-id");
        let courseObj = this.state.items.find((elm)=>elm.course_id === itemCourseId);
        removeCourseEventGoogleAnalytics(courseObj);
        this.setState({
            items: this.state.items.filter(item => item.course_id !== itemCourseId),
            sessionCartData: removeItem(this.state.sessionCartData, itemCourseId),
            totalUpdating: true,
        }, () => {
            //Check to see if there are any items left in the cart
            if(this.state.items.length > 0){
                this.itemsInCart(itemCourseId)
            }else{
                //Update to no item state
                this.noItemsInCart();
                //Remove the items from the session when done
                removeFromSessionCart(itemCourseId).then(response => updateCartUIElement(response.data.total));
            }
        });
    }

   async applyDiscountClickHandler(event){
        event.preventDefault();
        let discountInput = event.target.querySelector('.discount-field');
        let inputValidationPassed = (discountInput.value.trim().match(/^[0-9a-zA-Z_]+$/) !== null);

        if(inputValidationPassed){
            this.totalUpdatingState()
            var response = await getPurchaseAppData('/checkout/ordertotal', this.state.domainId, this.state.sessionCartData, discountInput.value.trim());

                //This path only triggers if the discount is valid, but no applicable items are in the cart
                if(response.data.discount){
                    if(response.data.discount.value === 0){
                        return this.handleNotApplicableDiscount(response.data.discount.discount_for);
                    }
                }
                this.setState({
                    purchaseApp: response.data,
                    items: transformPAData(this.state.sessionCartData, response.data),
                    totalUpdating: false,
                    totalCost: response.data.total,
                    subtotal: response.data.total_prediscount,
                    cartHasItems: true,
                    discountCode: response.data.discount,
                    volumeDiscount: response.data.volume_discount,
                    discountCodeAttempt: true,
                    discountNotApplicable: false,
                }, () => {
                    this.setState({cartData: makeCartDataJsonString(response.data, this.state.discountCode)})
                })

        }
        //Clear out the discount form input
        discountInput.value = '';
    }

    updateQuantityClickHandler(event){
        event.preventDefault();
        let quantity = event.target.querySelector('.cart_qty_field').value;
        let courseId = event.target.querySelector('.course_id').value;
        this.totalUpdatingState();
        this.updateCartDataQuanity(courseId, quantity);
    }

    totalUpdatingState(){
        this.setState({totalUpdating: true})
    }

    noItemsInCart(){
        this.setState({
            cartHasItems: false,
            totalUpdating: false,
            cartString: 'No Items In Cart',
            totalCartItems: 0,
        })
    }

    handleNotApplicableDiscount(discount_for){
        let message;
        switch(discount_for){
            case 'courses':
            message = "This discount code is valid, but can not be used on certificates. Please add an individual course to your cart to receive this discount."
            break;
            case 'suites':
            message = "This discount code is valid, but applies only to certificates. Please add a certificate to your cart to receive this discount."
            break;
        }
        this.setState({
            discountNotApplicable: true,
            discountNotApplicableMessage: message,
            totalUpdating: false
        });
    }

   async itemsInCart(itemCourseId){
       //if valid discount code set, send it with the update quanity request
       let discountCode = this.state.discountCode ? this.state.discountCode.code : '';
       var response =  await getPurchaseAppData('/checkout/ordertotal', this.state.domainId, this.state.sessionCartData,discountCode);
            if(response.status === 200 && response.data.message === undefined){
                this.setState({
                    purchaseApp: response.data,
                    items: transformPAData(this.state.sessionCartData, response.data),
                    totalUpdating: false,
                    cartData: makeCartDataJsonString(response.data,response.data.discount),
                    totalCartItems: countItems(response.data),
                    totalCost: response.data.total,
                    subtotal: response.data.total_prediscount,
                    volumeDiscount: response.data.volume_discount,
                    discountCode: response.data.discount
                }, () => {
                    //Remove the items from the session when done
                    removeFromSessionCart(itemCourseId).then(response => updateCartUIElement(response.data.total));
                })
            }
    }

    updateCartDataQuanity(courseId, quantity){
        //Modify cart with new quanity before PA api call
        let cData = {...this.state.sessionCartData};
        cData[courseId] = quantity;
        //if valid discount code set, send it with the update quanity request
        let discountCode = this.state.discountCode ? this.state.discountCode.code : '';
        this.setState({
            sessionCartData: cData,
        }, () => {
            getPurchaseAppData('/checkout/ordertotal', this.state.domainId, this.state.sessionCartData, discountCode)
            .then(response => {
                this.setState({
                    purchaseApp: response.data,
                    items: transformPAData(this.state.sessionCartData, response.data),
                    totalUpdating: false,
                    totalCost: response.data.total,
                    subtotal: response.data.total_prediscount,
                    cartHasItems: true,
                    totalCartItems: countItems(response.data),
                    cartData: makeCartDataJsonString(response.data, this.state.discountCode),
                    volumeDiscount: response.data.volume_discount,
                    discountCode: response.data.discount,
                })
                //Update the session cart with the new qauntity
                updateSessionCartQuantity(courseId, quantity)
                    .then((response) => {
                        if(response.status === 200){
                            updateCartUIElement(response.data.total);
                        }
                    })
            })
        })
    }

    render() {

        const getStatus = (this.state.totalUpdating) ? " cart-listing is--updating" : " cart-listing is--ready";
        const msgCheckoutButton = (this.state.totalUpdating) ? "disabled" : '';
        return (
            <div id="pageContentSub" className="page-content__block__t2 cart">
                <main>
                    <section className="page-section__block skye-cart-container">
                        <div className="form">
                            <ShopingCartHeader total={this.state.totalCartItems} />
                            <div className="row the-cart">
                                <div className={"col-md-8" + getStatus}>
                                    {(this.state.cartHasItems) ? this.state.items.map((item, index) => {
                                        return <ShoppingCartItem
                                                    key={item.course_id}
                                                    quantity={item.quantity}
                                                    course_id={item.course_id}
                                                    title={item.title}
                                                    unit_cost={item.unit_cost}
                                                    unit_total={item.unit_total}
                                                    remove_handler={this.removeItemHandler}
                                                    update_quantity={this.updateQuantityClickHandler}
                                                    cart_number={ index + 1 }
                                                />
                                    }):this.state.cartString}
                                    <div className="spinner__container">
                                    <div className="spinner__block">
                                    <div className="loader"></div>
                                    <div className="inner-circle"></div>
                                    </div>
                                    </div>
                                </div>

                                <ShoppingCartCta
                                    subtotal={this.state.subtotal}
                                    total={this.state.totalCost}
                                    isUpdating={this.state.totalUpdating}
                                    total_items={this.state.totalCartItems}
                                    cart_data={this.state.cartData}
                                    volume_discount={this.state.volumeDiscount}
                                    discount_code_attempt={this.state.discountCodeAttempt}
                                    discount_code={this.state.discountCode}
                                    discount_code_text={"SKYE20"}
                                    apply_discount={this.applyDiscountClickHandler}
                                    discount_not_applicable={this.state.discountNotApplicable}
                                    discount_not_applicable_message={this.state.discountNotApplicableMessage}
                                    disableBtn={msgCheckoutButton}
                                    hasCartItems={this.state.cartHasItems}
                                    checkout_url={this.state.checkout_url}
                                />
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        );
    }
}

export default ShoppingCartApp;
